import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const AboutUs: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-container about-page">
      <button className="back-button" onClick={() => navigate('/')}>← Back to Home</button>
      
      <h1>About Jollyio</h1>

      <section className="mission">
        <h2>Our Mission</h2>
        <p>
          Jollyio makes it easy for Houston-area parents to discover amazing kid-friendly events, activities, 
          and experiences. We believe every child deserves opportunities to learn, play, and grow—and parents 
          shouldn't have to spend hours searching multiple websites to find them.
        </p>
      </section>

      <section>
        <h2>What We Do</h2>
        <p>
          We aggregate information about thousands of kid-friendly activities from across the Houston metro area, including:
        </p>
        <ul>
          <li>🎉 Free library events and story times</li>
          <li>🎂 Birthday party venues and packages</li>
          <li>🎓 Classes in music, sports, and martial arts</li>
          <li>⚽ Youth sports leagues and activities</li>
          <li>🏕️ Winter, spring, and summer camps</li>
          <li>🎢 Attractions, zoos, and museums</li>
          <li>🏫 School district calendars and events</li>
        </ul>
        <p>
          All in one convenient place, organized by location, age, and category.
        </p>
      </section>

      <section>
        <h2>How It Works</h2>
        <p>
          We collect event information from publicly available sources, including:
        </p>
        <ul>
          <li>Houston-area public library calendars</li>
          <li>Parks and recreation departments</li>
          <li>School district websites</li>
          <li>Venue websites and social media</li>
          <li>Community organizations</li>
        </ul>
        <p>
          Our technology automatically gathers and organizes this information so you don't have to visit 
          dozens of websites to plan your family's week.
        </p>
      </section>

      <section>
        <h2>Coverage Area</h2>
        <p>
          Currently, Jollyio serves 10 cities in the Houston metro area:
        </p>
        <div className="cities-grid">
          <span>🏙️ Houston</span>
          <span>🏙️ Sugar Land</span>
          <span>🏙️ Katy</span>
          <span>🏙️ Pearland</span>
          <span>🏙️ The Woodlands</span>
          <span>🏙️ Spring</span>
          <span>🏙️ Cypress</span>
          <span>🏙️ Humble</span>
          <span>🏙️ Missouri City</span>
          <span>🏙️ League City</span>
        </div>
      </section>

      <section>
        <h2>Why We Built Jollyio</h2>
        <p>
          As parents ourselves, we know how challenging it can be to find age-appropriate activities for kids. 
          Events are scattered across library websites, park districts, school calendars, and venue pages. 
          We created Jollyio to solve this problem—bringing all these opportunities together in one searchable, 
          filterable platform.
        </p>
      </section>

      <section>
        <h2>Our Commitment</h2>
        <ul>
          <li>✅ <strong>Always Free to Browse:</strong> Access to event information is completely free</li>
          <li>✅ <strong>Unbiased Information:</strong> We don't promote one venue over another</li>
          <li>✅ <strong>Privacy First:</strong> We don't sell your data or spam you with emails</li>
          <li>✅ <strong>Parent-Focused:</strong> Built by parents, for parents</li>
          <li>✅ <strong>Constantly Updated:</strong> New events added daily</li>
        </ul>
      </section>

      <section>
        <h2>What's Coming Next</h2>
        <p>
          We're constantly improving Jollyio. Here's what's in the works:
        </p>
        <ul>
          <li>🤖 AI-powered event recommendations</li>
          <li>📧 Weekly email digests of events you'll love</li>
          <li>📅 Calendar integration</li>
          <li>🔔 Reminders for saved events</li>
          <li>🗺️ More cities across Texas</li>
        </ul>
      </section>

      <section>
        <h2>Get in Touch</h2>
        <p>
          We'd love to hear from you! Whether you have suggestions, found an issue, or just want to say hi:
        </p>
        <p><strong>Email:</strong> support@jollyio.com</p>
        <p>
          Follow us for updates and tips on making the most of Jollyio.
        </p>
      </section>

      <section className="cta-section">
        <h2>Start Exploring Today</h2>
        <p>
          Join hundreds of Houston parents discovering amazing events for their kids.
        </p>
        <button className="cta-button" onClick={() => navigate('/')}>
          Discover Events →
        </button>
      </section>
    </div>
  );
};

export default AboutUs;
